import {
  processingGroupIdFormat,
  sortingToteIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod";
import { ToteNamingConfigSchema } from "./tote-naming-config";

export const addSortingTotes = {
  name: "addSortingTotes" as const,
  input: z.object({
    processingGroupId: processingGroupIdFormat.schema,
    count: z.number().int().positive(),
    namingConfig: ToteNamingConfigSchema.optional(),
  }),
  output: z.object({ toteIds: z.array(sortingToteIdFormat.schema) }),
};
